import Column from './Column';
export default Column;



// WEBPACK FOOTER //
// ./src/components/Column/index.js